import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Badge, Modal, message } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { isInstallerNativeApp } from '../utils/installerSms';
import {
    addBufferedPhoto,
    subscribePhotoBuffer
} from '../utils/installerPhotoBuffer';
import { listActiveTasks } from '../utils/installerWoSms';

const InstallerPhotoFab = () => {
    const inputRef = useRef(null);
    const [native, setNative] = useState(false);
    const [sheetOpen, setSheetOpen] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [pickerOpen, setPickerOpen] = useState(false);
    const [targetTaskId, setTargetTaskId] = useState(null);

    useEffect(() => {
        setNative(isInstallerNativeApp());
        setTasks(listActiveTasks());

        const onActive = event => {
            setTasks(
                Array.isArray(event.detail)
                    ? event.detail
                    : listActiveTasks()
            );
        };
        const onSheet = event => {
            setSheetOpen(Boolean(event.detail?.open));
        };

        window.addEventListener('installer-active-tasks', onActive);
        window.addEventListener('installer-task-sheet', onSheet);
        const unsub = subscribePhotoBuffer(setPhotos);
        return () => {
            window.removeEventListener(
                'installer-active-tasks',
                onActive
            );
            window.removeEventListener(
                'installer-task-sheet',
                onSheet
            );
            unsub();
        };
    }, []);

    const count = useMemo(() => {
        if (!tasks.length) return photos.length;
        const ids = new Set(tasks.map(t => Number(t.id)));
        return photos.filter(p => ids.has(Number(p.taskId))).length;
    }, [photos, tasks]);

    if (!native || !tasks.length || sheetOpen) {
        return null;
    }

    const shootFor = taskId => {
        setTargetTaskId(taskId);
        setPickerOpen(false);
        setTimeout(() => inputRef.current?.click(), 50);
    };

    const openCamera = () => {
        if (tasks.length === 1) {
            shootFor(tasks[0].id);
            return;
        }
        setPickerOpen(true);
    };

    const onFile = async event => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (!file || !targetTaskId) return;
        try {
            await addBufferedPhoto({
                taskId: targetTaskId,
                file
            });
            message.success(
                'Фото в буфере. Попадёт в отчёт, когда откроете заявку'
            );
        } catch (error) {
            message.error(
                error?.message || 'Не удалось сохранить фото'
            );
        }
    };

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={onFile}
            />
            <button
                type="button"
                className="installer-photo-fab"
                onClick={openCamera}
            >
                <Badge count={count} size="small" offset={[-2, 2]}>
                    <CameraOutlined />
                </Badge>
                <span>По дороге</span>
            </button>

            <Modal
                title="К какой заявке фото?"
                open={pickerOpen}
                onCancel={() => setPickerOpen(false)}
                footer={null}
                destroyOnClose
            >
                {tasks.map(task => (
                    <button
                        key={task.id}
                        type="button"
                        className="installer-work-card"
                        style={{
                            width: '100%',
                            textAlign: 'left'
                        }}
                        onClick={() => shootFor(task.id)}
                    >
                        <div className="installer-work-card__title">
                            {task.ttNumber
                                ? `ТТ ${task.ttNumber}`
                                : task.title}
                        </div>
                        <div className="installer-work-card__meta">
                            {task.title}
                        </div>
                    </button>
                ))}
            </Modal>
        </>
    );
};

export default InstallerPhotoFab;
